import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-components';
/**
 * Render the final JSX of SensitivityLabel
 */
export const renderSensitivityLabel_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsx(state.root, {
    children: state.tooltip ? /*#__PURE__*/_jsx(state.tooltip, {
      children: state.label && /*#__PURE__*/_jsx(state.label, {})
    }) : state.label && /*#__PURE__*/_jsx(state.label, {})
  });
};
//# sourceMappingURL=renderSensitivityLabel.js.map